import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getActivities, getObjects } from "./stepFive.thunks";

interface StepFiveStateInterface {
	data: any[];
	objects: any[];
	activities: any[];
	statuses: any;
	search: string;
	sortBy: any;
	statusFilter: any;
	loading: boolean;
	error: string;
}

const initialState: StepFiveStateInterface = {
	data: [],
	objects: [],
	activities: [],
	statuses: [
		{
			id: 1,
			name: "Утверждено",
		},
		{
			id: 2,
			name: "Частично утверждено",
		},
		{
			id: 3,
			name: "Не утверждено",
		},
	],

	sortBy: {
		activities: { id: 0 },
		objects: { id: 0 },
		statuses: { id: 0 },
	},
	statusFilter: { name: "0", text: "Все" },
	search: "",
	loading: false,
	error: "",
};

const stepFiveSlice = createSlice({
	name: "stepFiveSlice",
	initialState,
	reducers: {
		setSearch(state, action: PayloadAction<string>) {
			state.search = action.payload;
		},

		setSortBy(state, action: PayloadAction<any>) {
			state.sortBy = {
				...state.sortBy,
				[action.payload.type]: { id: action.payload.sort },
			};
		},

		setStatusFilter(state, action: PayloadAction<any>) {
			state.statusFilter = action.payload;
		},

		setData(state, action: PayloadAction<any>) {
			state.data = action.payload;
		},

		updateData(state, action: PayloadAction<any>) {
			state.data = [...state.data, ...action.payload];
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getActivities.pending, (state) => {
			state.loading = false;
		});

		builder.addCase(getActivities.fulfilled, (state, action) => {
			state.activities = action.payload;
			state.error = action.payload as any;
			state.loading = false;
		});

		builder.addCase(getActivities.rejected, (state, action) => {
			state.error = action.payload as any;
			state.loading = false;
		});

		builder.addCase(getObjects.pending, (state) => {
			state.loading = false;
		});

		builder.addCase(getObjects.fulfilled, (state, action) => {
			state.objects = action.payload;
			state.error = action.payload as any;
			state.loading = false;
		});

		builder.addCase(getObjects.rejected, (state, action) => {
			state.error = action.payload as any;
			state.loading = false;
		});
	},
});

export const { setSearch, setSortBy, setStatusFilter, setData, updateData } = stepFiveSlice.actions;
export default stepFiveSlice.reducer;
